import { useEffect, type ReactNode } from 'react';

import { useThemeStore } from './theme.store';

/**
 * Aplica el tema actual al documento al montar (importante para SSR-safe
 * y para escenarios donde el store ya tenía un valor distinto al default).
 */
export function ThemeProvider({ children }: { children: ReactNode }) {
  const theme = useThemeStore((s) => s.theme);

  useEffect(() => {
    const root = document.documentElement;
    if (theme === 'dark') root.classList.add('dark');
    else root.classList.remove('dark');
  }, [theme]);

  return <>{children}</>;
}
